<template>
    <section class="login-bg">
        <v-container>
            <v-row class="d-flex justify-center align-center mt-16">
                <v-col cols="12" md="4">
                    <div class="d-flex flex-column align-center mt-6" style="font-family: Inter, sans-serif; color: #FFFFFF;">
                        <v-img class="w-50 ml-n1" src="../assets/tab_logo.png"></v-img>
                        <div class="text-h6 font-weight-bold mt-2" style="font-family: Stalinist One, sans-serif;">Welcome, Admin</div>
                        <div class="mt-4 font-weight-bold">Sign in to continue access</div>
                    </div>
                </v-col>
                <v-col cols="12" md="5" class="mt-16">
                    <v-form ref="Formref">
                        <v-card height="320" rounded="lg" elevation="6" color="primary" class="d-flex">
                            <v-container>
                                <v-row dense>
                                    <v-col cols="12" class="mt-16 px-8">
                                        <div class="d-flex">
                                            <div class="mt-2 mr-4" style="font-family: Saira Condensed, sans-serif; color: #FFFFFF;">USERNAME:</div>
                                            <v-text-field
                                            v-model="username"
                                            :rules="[formRules.required]"
                                            variant="solo"
                                            bg-color="#FFFFFF"
                                            type="email"
                                            class="text-subtitle-2"
                                            density="compact"
                                            style="font-family: Saira Condensed, sans-serif;"
                                            >
                                            </v-text-field>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" class="px-8">
                                        <div class="d-flex">
                                            <div class="mt-2 mr-4" style="font-family: Saira Condensed, sans-serif; color: #FFFFFF;">PASSWORD:</div>
                                        <v-text-field
                                        v-model="password"
                                        :rules="[formRules.required]"
                                        variant="solo"
                                        :append-inner-icon="showPass ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                                        :type="showPass ? 'text' : 'password'"
                                        @click:append-inner="showPass = !showPass"
                                        bg-color="#FFFFFF"
                                        class="text-subtitle-2"
                                        style="font-family: Saira Condensed, sans-serif;"
                                        density="compact"
                                        >
                                        </v-text-field>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" class="text-center">
                                        <v-btn
                                        @click="dologin()"
                                        :loading="loading"
                                        color="#FF0000"
                                        height="40px"
                                        style="font-family: Saira Condensed, sans-serif;"
                                        >
                                            Login
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-form>
                </v-col>
            </v-row>
            <v-row class="d-flex justify-center align-center">
                <v-col cols="12">
                    <div class="mt-4 text-caption font-weight-bold text-center" style="font-family: Stalinist One, sans-serif">IF YOU ARE A USER, PLEASE VISIT <a href="https://www.romieinc.com" style="text-decoration: none;"><span style="color: #FF0000;">WWW.ROMIEINC.COM</span></a></div>
                </v-col>
            </v-row>
        </v-container>
    </section>
    <v-snackbar
        v-model="snackbar"
        :timeout="2500"
        color="secondary"
        location="top">
        <v-icon>mdi-alert-circle</v-icon>
        <span class="ml-2">{{ snackText }}</span>
    </v-snackbar>
</template>

<script>    
import axios from 'axios';
import { defineComponent } from 'vue';
export default defineComponent({
    data() {
        return {
            username: null,
            password: null,
            snackbar: false,
            snackText: null,
            showPass: false,
            loading: false,
        }
    },  
    methods: {
        dologin() {
            if (this.$refs.Formref.validate()) {
                this.loading = true
                let data = {
                    username: this.username,
                    password: this.password
                };
                axios.post(process.env.VUE_APP_SERVER_URL + '/api/admin/auth/adminLogin', data, 
                { headers: 
                    { 
                     'Content-Type': 'application/json',
                     'x-admin-key': process.env.VUE_APP_X_ADMIN_KEY,
                    }
                } 
                ).then((res)=>{
                   this.loading = false
                   this.snackbar = true
                   this.snackText ='Logging in ...'
                   localStorage.setItem("romieinc-admin-accesstoken", res.data.accessToken)
                   this.$store.commit('UPDATE_USER', res.data.user)
                   window.location.reload()
                }).catch((error) => {
                    if (error.response) {
                        if (error.response.status === 401) {
                            this.snackbar = true
                            this.snackText ='Wrong Credentials'
                            this.loading = false
                        } else {
                            console.log(`Error: ${error.response.status}`);
                            if(error.response.status == 400){
                                this.snackbar = true
                                this.snackText ='Wrong Credentials'
                                this.loading = false
                            }
                        }
                    } 
                    else if (error.request) {
                        console.log('No response received', error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            }
        },
        redirectToGoogleAuth() {
        // Redirect the user to the Google OAuth2.0 authentication URL
        window.location.href = this.googleAuthURL;
        },
    },
})
</script>

<style  scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');

.login-bg {
	background-image: url('../assets/main-page-bg.png');
	background-repeat: no-repeat;
	background-size: cover;

    height: 100vh;
}
</style>